import React from 'react';

// A keycap badge. Used both inline on an option button (P / F / N) and in the
// KeyHintBar along the bottom of a keyboard-driven screen.
//
// `tone` matches the option it sits on so the cap reads as part of the control
// rather than a sticker on top of it: on an unanswered option the cap is muted,
// on the answered/active one it inherits the option's own colour.
export default function Kbd({ children, tone = 'default', style }) {
  const tones = {
    default: { fg: 'var(--text-muted)', border: 'var(--border-default)', bg: 'var(--surface-default)' },
    // --text-ghost is only 2.54:1 on white, so the keycap uses --text-muted
    // (7.56:1). The cap must stay readable — it is the shortcut, not decoration.
    ghost:   { fg: 'var(--text-muted)', border: 'var(--border-subtle)',  bg: 'transparent' },
    success: { fg: 'var(--success-text)', border: 'var(--success-border)', bg: 'var(--success-fill)' },
    danger:  { fg: 'var(--danger-text)',  border: 'var(--danger-border)',  bg: 'var(--danger-fill)' },
  };
  const t = tones[tone] || tones.default;
  return (
    <span
      aria-hidden="true"
      style={{
        fontFamily: 'var(--font-mono)', fontSize: 11, fontWeight: 600, lineHeight: '16px',
        color: t.fg, background: t.bg, border: `1px solid ${t.border}`,
        borderRadius: 'var(--radius-sm)', padding: '0 5px', flexShrink: 0, ...style,
      }}>{children}</span>
  );
}
